import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CommonState, BrowseType } from "./types";

import { RootState } from "lib/store";
import { InfluencerType } from "../influencer/types";
import { BusinessType } from "../business/types";

const initialState: CommonState = {
  businessTypesData: [],
  influencerTypesData: [],
  browseType: "bookableExperience",
};

// Slice
export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setBusinessTypesData(
      state: CommonState,
      action: PayloadAction<BusinessType[]>
    ) {
      state.businessTypesData = action.payload;
    },
    setInfluencerTypesData(
      state: CommonState,
      action: PayloadAction<InfluencerType[]>
    ) {
      state.influencerTypesData = action.payload;
    },
    setBrowseType(state: CommonState, action: PayloadAction<BrowseType>) {
      state.browseType = action.payload;
    },
  },
});

const selectSlice = (state: RootState) => state.commonSlice || initialState;

export const selectBusinessTypeData = createSelector(
  [selectSlice],
  (state: CommonState) => state.businessTypesData
);

export const selectInfluencerTypeData = createSelector(
  [selectSlice],
  (state: CommonState) => state.influencerTypesData
);

export const selectBrowseType = createSelector(
  [selectSlice],
  (state: CommonState) => state.browseType
);

export const { setBusinessTypesData, setInfluencerTypesData, setBrowseType } =
  commonSlice.actions;

export default commonSlice.reducer;
